import React from 'react';
import { ImSpinner10 } from 'react-icons/im';
import '../../App.css';

export default function LoaderSpinner() {
    return (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
            <ImSpinner10 size={50} className='animate-spin spinner-color'/>
        </div>
    )
};
export const CustomLoader = ()=> {
    return <ImSpinner10 size={50} className='animate-spin spinner-color'/>;
}